import React from 'react';
import { Controller, FieldPath, FieldValues } from 'react-hook-form';
import { StyledQuestionFieldContainer } from '../Questionnaires/QuestionnairePage/components/QuestionViewerEditor/QuestionEditor/styles';
import { InputProps } from './types';
import InputColor from '../Shared/InputColor';

interface ColorEditorProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>
  extends InputProps<TFieldValues, TName> {
  label: string;
}

function ColorEditor<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  label
}: ColorEditorProps<TFieldValues, TName>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <StyledQuestionFieldContainer>
          <InputColor error={fieldState.error?.message} name={field.name} value={field.value} onChange={field.onChange} label={label} />
        </StyledQuestionFieldContainer>
      )}
    />
  );
}

export default ColorEditor;
